import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BillingUser, BillingUserPermission } from "../types";

export type AddBillingUserPayload = {
  email: string;
  permissions: BillingUserPermission[];
};

export const addBillingUserRequest = (
  billingProfileId: string,
  payload: AddBillingUserPayload
) => {
  return apiProxyRequest<BillingUser>(
    `/billing/profiles/${billingProfileId}/users`,
    "POST",
    payload
  );
};
